import React from 'react';
import { ViewDetailsDesktopModalContent } from './ViewDetailsDesktopModalContent';
import { ViewDetailsMobileModalContent } from './ViewDetailsMobileModalContent';


export const ViewDetailsModalContent = React.forwardRef(
  function(props, ref) {
    return(
      <>
        <ViewDetailsDesktopModalContent
          ref={ref}
          {...props}
        />
        <ViewDetailsMobileModalContent
          ref={ref}
          {...props}
        />
      </>
    )
  }
)
